import React from "react" // eslint-disable-line no-unused-vars
import { ListItem } from "../../common/ListItem"
import { checkEitherHasItems } from "../../../utils/data"

/** @jsx jsx */
import { jsx, Box } from "theme-ui"

const pathwaysOrPlatforms = (programmePathways, programmePlatforms) => {
  let pathwaysPlatformsTitle

  if (programmePathways?.length > 0) {
    if (programmePlatforms?.length > 0) {
      pathwaysPlatformsTitle = "Pathways / Platforms"
    } else {
      pathwaysPlatformsTitle = "Pathways"
    }
  } else {
    if (programmePlatforms?.length > 0) {
      pathwaysPlatformsTitle = "Platforms"
    } else {
      pathwaysPlatformsTitle = ""
    }
  }
  return pathwaysPlatformsTitle
}

const checkIfOnlyPathways = (programmePathways, programmePlatforms) => {
  if (programmePathways?.length > 0 && programmePlatforms?.length === 0) {
    return true
  } else {
    return false
  }
}

const checkIfOnlyPlatforms = (programmePathways, programmePlatforms) => {
  if (programmePathways?.length === 0 && programmePlatforms?.length > 0) {
    return true
  } else {
    return false
  }
}

const PathwayList = ({ platforms }) => {
  return (
    <ul
      sx={{
        p: 0,
        m: 0,
        listStyle: "none",
      }}
    >
      {platforms.map((pathway, i) => {
        return (
          <ListItem
            key={`platform${i}`}
            icon="chevron"
            to={`/programmes/${pathway.slug.current}`}
            topBorder={false}
            leftBorder={false}
            rightBorder={false}
            size="navigation"
            tagName="li"
            sx={{ py: [1, 2] }}
          >
            {pathway.programmeName}
          </ListItem>
        )
      })}
    </ul>
  )
}

const PathwayPlatformBlock = ({ programmePathways, programmePlatforms }) => {
  return (
    <Box>
      {/* Pathways and Platforms */}
      {checkEitherHasItems(programmePathways, programmePlatforms) && (
        <Box>
          <ListItem
            leftBorder={false}
            rightBorder={false}
            size="large"
            tagName="h2"
          >
            {pathwaysOrPlatforms(programmePathways, programmePlatforms)}
          </ListItem>
        </Box>
      )}
      {/* Pathways */}
      {programmePathways.length > 0 && (
        <Box
          sx={{
            mt: [6, 0],
            borderTopColor: "text",
            borderTopStyle: "solid",
            borderTopWidth: [1, 0],
          }}
        >
          {!checkIfOnlyPathways(programmePathways, programmePlatforms) && (
            <Box>
              <ListItem
                size="normal"
                tagName="p"
                topBorder={false}
                leftBorder={false}
                rightBorder={false}
                sx={{ py: [2, 3] }}
              >
                Pathways
              </ListItem>
            </Box>
          )}

          <Box>
            <PathwayList platforms={programmePathways} />
          </Box>
        </Box>
      )}
      {/* Platforms */}
      {programmePlatforms.length > 0 && (
        <Box>
          {!checkIfOnlyPlatforms(programmePathways, programmePlatforms) && (
            <Box>
              <ListItem
                size="normal"
                tagName="p"
                topBorder={false}
                leftBorder={false}
                rightBorder={false}
                sx={{ py: [2, 3] }}
              >
                Platforms
              </ListItem>
            </Box>
          )}
          <Box
            sx={{
              mt: [6, 0],
              borderTopColor: "text",
              borderTopStyle: "solid",
              borderTopWidth: [1, 0],
            }}
          >
            <PathwayList platforms={programmePlatforms} />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default PathwayPlatformBlock
